import { render, staticRenderFns } from "./captainOrder.vue?vue&type=template&id=3c5e2330"
import script from "./captainOrder.vue?vue&type=script&lang=js"
export * from "./captainOrder.vue?vue&type=script&lang=js"
import style0 from "./captainOrder.vue?vue&type=style&index=0&id=3c5e2330&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports